import React from 'react';
import {Route} from 'react-router-dom';
import Async from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <Route key="/business/beauty-fashion-metaverse" element={<BlankLayout />}>
    <Route path="business/beauty-fashion-metaverse" element={<Async />} />
  </Route>,
  <Route key="/business/CES2022" element={<BlankLayout />}>
    <Route path="business/CES2022" element={<Async />} />
  </Route>,
];
